<template>
  <div id="page-personal">
    <div class="form-wrap">
      <div class="form-item">
        <span>所属用户组：</span>
        <Input v-model="user.group" placeholder="请输入所属用户组..." disabled></Input>
      </div>
      <div class="form-item">
        <span>姓名：</span>
        <Input v-model="user.userName" placeholder="请输入您的姓名..." disabled></Input>
      </div>
      <div class="form-item">
        <span>用户名：</span>
        <Input v-model="user.realName" placeholder="请输入用户名..." disabled></Input>
      </div>
    </div>
    <div class="btn-wrap">
      <div class="btn-changePwd" @click="showDialog">修改密码</div>
    </div>
    <!-- 修改密码模态框 -->
    <div class="modal-mask" v-show="isShowDialog">
      <div class="modal">
        <div class="modal-header">
          <span class="modal-title">修改密码</span>
          <span class="icon-close" @click="handleCancel"></span>
        </div>
        <div class="modal-content">
          <Row :gutter="16" style="margin-top:15px" class="row row-originPwd">
            <Col span="5" class="col-l">
              <span>原始密码</span>
            </Col>
            <Col span="19" class="col-r">
              <input
                type="password"
                class="input-originPwd"
                placeholder="请输入原始密码"
                v-model="password.origin"
              />
            </Col>
          </Row>
          <Row :gutter="16" style="margin-top:15px" class="row row-newPwd">
            <Col span="5" class="col-l">
              <span>新密码</span>
            </Col>
            <Col span="19" class="col-r">
              <input
                type="password"
                class="input-newPwd"
                placeholder="请输入6-12位密码"
                v-model="password.new"
                maxlength="12"
              />
            </Col>
          </Row>
          <Row :gutter="16" style="margin-top:15px" class="row row-repeatPwd">
            <Col span="5" class="col-l">
              <span>确认新密码</span>
            </Col>
            <Col span="19" class="col-r">
              <input
                type="password"
                class="input-repeatPwd"
                placeholder="二次确认密码"
                v-model="password.repeat"
                maxlength="12"
              />
            </Col>
          </Row>
        </div>
        <div class="modal-footer">
          <div class="btn-confirm" @click="handleConfirm">确认</div>
          <div class="btn-cancel" @click="handleCancel">取消</div>
        </div>
      </div>
    </div>
    <!-- loading动画 -->
    <loading :isLoading="isLoading"></loading>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //是否显示模态框
      isLoading: false,
      //用户信息
      user: {
        //所属用户组
        group: "",
        //用户名
        userName: "",
        //姓名
        realName: ""
      },
      //是否显示模态框信息
      isShowDialog: false,
      //修改密码
      password: {
        //原始密码
        origin: "",
        //新密码
        new: "",
        //确认新密码
        repeat: ""
      }
    };
  },
  mounted() {
    //获取用户信息
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.$ajax({
        method: "get",
        url: "./userInfo"
      })
        .then(res => {
          this.isLoading = false;
          if (res.data.success) {
            this.user.group = res.data.data.customGroupName;
            this.user.userName = res.data.data.name;
            this.user.realName = res.data.data.username;
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.$Message.error("服务器错误");
          console.log(err);
        });
    },
    //点击<修改密码>按钮
    showDialog() {
      this.isShowDialog = true;
    },
    //点击修改密码<确认>按钮
    handleConfirm() {
      if (this.isLoading) return;
      if (this.verifyPassword()) {
        this.isLoading = true;
        this.$ajax({
          method: "post",
          url: "./changePasswd",
          data: this.$qs.stringify({
            oldPassword: this.password.origin,
            newPassword: this.password.new,
            newPasswordAgain: this.password.repeat
          })
        })
          .then(res => {
            this.isLoading = false;
            if (res.data.success) {
              this.$Message.success("密码修改成功");
              //关闭模态框
              this.isShowDialog = false;
              //初始化密码数据
              this.initPwdData();
            } else {
              if (res.data.code !== 405) {
                this.$Message.error("服务器错误");
              }
            }
          })
          .catch(err => {
            this.isLoading = false;
            this.$Message.error("服务器错误");
            console.log(err);
          });
      }
    },
    //点击修改密码<取消>按钮
    handleCancel() {
      this.initPwdData();
      this.isShowDialog = false;
    },
    //清空修改密码模态框数据
    initPwdData() {
      this.password.origin = this.password.new = this.password.repeat = "";
    },
    //校验密码格式是否正确
    verifyPassword() {
      if (this.password.new != this.password.repeat) {
        this.$Message.error("两次输入的密码不一致");
        return false;
      }
      //校验密码长度6-12
      let regex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*_)[a-zA-Z\d_]{8,12}$/;
      if (!regex.test(this.password.new)) {
        this.$Message.error("新密码为8-12位，必须包含数字、字母、下划线");
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="less">
#page-personal {
  .form-wrap {
    margin: 0 auto;
    width: 500px;
    margin-top: 200px;
    .form-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;
      span {
        display: inline-block;
        text-align: right;
        margin-right: 20px;
        line-height: 32px;
        width: 150px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #666666;
      }
    }
  }
  .btn-wrap {
    width: 500px;
    margin: 0 auto;
    .btn-changePwd {
      float: right;
      height: 40px;
      width: 385px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      background-color: #415af6;
      color: #fff;
      text-align: center;
      line-height: 40px;
      transition: all 0.2s ease;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .modal-mask {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 999;
    top: 0;
    left: 0;
    transition: all 0.3s ease-in;
    .modal {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 500px;
      transform: translate(-50%, -50%);
      background: #fff;
      box-shadow: 0 0 30px 0 #c8c7cc;
      border-radius: 4px;
      padding-bottom: 50px;
      .modal-header {
        height: 60px;
        border-bottom: 1px solid #efeff4;
        text-align: left;
        padding-left: 27px;
        position: relative;
        .modal-title {
          line-height: 60px;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #333333;
        }
        .icon-close {
          position: absolute;
          right: 28px;
          top: 50%;
          transform: translate(0, -50%);
          height: 20px;
          width: 20px;
          line-height: 60px;
          background: url("https://static.rong360.com/upload/png/6c/9c/6c9c09640ef8a6a010b1f3b69b0f94bf.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .modal-content {
        padding: 0 25px;
        .row {
          .col-l {
            text-align: right;
            span {
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #666666;
              letter-spacing: -0.33px;
              text-align: left;
              line-height: 30px;
            }
          }
          .col-r {
            .input-originPwd,
            .input-newPwd,
            .input-repeatPwd {
              width: 100%;
              height: 30px;
              border: 1px solid #d8d9dc;
              border-radius: 4px;
              outline: none;
              padding-left: 15px;
              line-height: 30px;
              transition: all 0.2s ease-in;
            }
            .input-originPwd:focus,
            .input-newPwd:focus,
            .input-repeatPwd:focus {
              border: 1px solid #1e90ff;
              border-color: #1e90ff;
              box-shadow: 0 0 3px #1e90ff;
            }
          }
        }
      }
      .modal-footer {
        display: flex;
        justify-content: center;
        margin-top: 30px;
        .btn-confirm {
          background: #415af6;
          margin-left: 20px;
          border-radius: 4px;
          height: 40px;
          line-height: 40px;
          width: 153px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: -0.33px;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          &:hover {
            opacity: 0.8;
          }
        }
        .btn-cancel {
          color: #415af6;
          border: 1px solid #415af6;
          border-radius: 4px;
          height: 40px;
          line-height: 40px;
          width: 153px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          letter-spacing: -0.33px;
          margin-left: 15px;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>